<template>
<div>
    <div v-show="!isEditing">
        <div>
            <div class="card-header">
                <p class="card-header-title">{{ data.title }} ({{ displayTriggerType(data.triggerType) }})</p>
            </div>
            <footer class="card-footer">
                <a href="#" class="card-footer-item" v-on:click="editData()">Edit</a>
                <a href="#" class="card-footer-item" v-on:click="deleteData(data)">Delete</a>
            </footer>
        </div>
    </div>

    <div style="border: 1px solid #CCC; padding: 10px;" v-show="isEditing">                
        <div class="card-header">
            <p class="card-header-title">Edit Badge</p>
        </div>
        <div class="card-content">
            <div class="content">            
                <div class="columns">
                    <div class="column is-full">
                        <input class="input is-success" type="text" placeholder="Title" v-model="data.title">
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-2">Image:</div>
                    <div class="column is-3"><img v-bind:src="displayLogoThumb(data.logoID)" alt="Current badge image"></div>
                    <div class="column is-7">
                        <b-radio v-model="isReplaceImage" native-value="0">
                            Use current
                        </b-radio>
                        <b-radio v-model="isReplaceImage" native-value="1">
                            Replace
                        </b-radio>
                    </div>
                </div>

                <div class="columns" v-show="isReplaceImage === '1'">
                    <div class="column is-full">
                        New image:
                        <v-select :options="options" label="title" class="badgeDropdown" key="_id" v-model="newLogoID">
                            <template slot="option" slot-scope="option">
                                <img :src="option.thumb" class="badgeImage" />
                                <div class="badgeTitle">{{ option.title }}</div>
                            </template>
                        </v-select>         
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-full">
                        <div class="myLabel">Colour:</div> 
                        <verte picker="square" model="hex" v-model="data.logoColour" style="margin-top: 3px; z-index: 200 !important;"></verte>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-2">Trigger:</div>
                    <div class="column is-10">
                            <b-radio v-model="data.triggerType" native-value="1" value="1" disabled="true">
                                Predefined Award
                            </b-radio>
                            <b-radio v-model="data.triggerType" native-value="2" value="2">
                                Custom Award
                            </b-radio>
                    </div>
                </div>

                <div class="columns" v-if="data.triggerType === '1'">
                    <div class="column is-4">Predefined Award:</div>
                    <div class="column is-8"><b-select id="predefinedTrigger" name="predefinedTrigger" v-model="data.predefinedTrigger">
                        <option selected value="1">Top in class (month)</option>
                        <option value="2">Top in school (month)</option>
                    </b-select></div>
                </div>

                <div class="field" id="customTriggerBox" v-show="data.triggerType === '2'">
                    <multiselect v-model="data.customTrigger" :options="customTriggerOptions" :close-on-select="true" :multiple="true" :hide-selected="true" label="name" track-by="name" placeholder="Select behaviors to award this badge to"></multiselect>
                    <i>For the time being, please select ONLY ONE behavior, else the badge won't work.</i>
                </div>

                <div class="columns" v-show="data.triggerType === '2'">
                    <div class="column is-2">Threshold:</div>
                    <div class="column is-10"><input class="input" type="number" placeholder="The minimum number of points to achive to receive this badge" v-model="data.threshold"></div>
                </div>        

                <!-- <div class="columns" v-show="data.triggerType === '2'">
                    <div class="column is-full">
                        <b-radio v-model="data.thresholdType" native-value="1" value="1">
                            Combination of all or any of the selected behavior's points is above the threshold value
                        </b-radio>
                        <b-radio v-model="data.thresholdType" native-value="2" value="2" style="margin-left:0em !important;">
                            All selected behavior's points must each be above the threshold value
                        </b-radio>
                    </div>
                </div> -->
                
                <div class="field">
                    <div class="control">
                        <div class="myLabel">Status:</div> 
                        <div class="myInput">
                            <b-radio v-model="data.status" native-value="1">
                                Active
                            </b-radio>
                            <b-radio v-model="data.status" native-value="0">
                                Inactive
                            </b-radio>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <button class='button is-primary' v-on:click="updateData(data,isReplaceImage,newLogoID)">Update</button>
                    <button class='button is-secondary' v-on:click="cancelEdit()">Close</button>
                </div>
            </div>
        </div>     
    </div>
</div>
</template>

<script>
import axios from 'axios'
import Verte from 'verte';
import 'verte/dist/verte.css';
import Multiselect from 'vue-multiselect'

export default {
    props: ['data'],
    data() {
        return {
            isEditing: false,
            options: [],
            customTriggerOptions: [{
                _id: '',
                name: '',
            }],
            isReplaceImage: '0',
            newLogoID: ''
        };
    },
    components:{
        Verte,
        Multiselect
    },
    created() {
        this.getBadgesImages();
        this.getCustomTriggerOptions();
        //we need to do as below, else the v-if="data.triggerType === '1' won't work on init
        this.data.triggerType = this.data.triggerType + ""
    },
    methods: {
        getBadgesImages(){
            let self = this;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/badges/logo/list', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID')
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    self.options = response.data
                    for (var i = 0; i < self.options.length; i++){
                        self.options[i].thumb = "http://admin.studentqr.com/badges/" + self.options[i].thumb
                    }
                })
                .catch(e => {
                    console.log(e)
                })
        },
        getCustomTriggerOptions(){
            let self = this;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/auth/positive/list', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID')
                    }
                })
                .then(response => {
                    self.customTriggerOptions = response.data
                })
                .catch(e => {
                    console.log(e)
                })
        },
        displayTriggerType(triggerType){
            if (triggerType == 1){
                return "Predefined Award"
            }else{
                return "Custom Award"
            }
        },
        displayLogoThumb(logoID){
            var foundCurrentImage = this.options.find(obj => obj._id == logoID);
            if (foundCurrentImage != null){
                return foundCurrentImage.thumb
            }
        },
        deleteData(data) {
            this.$emit('delete-data', data);
        },
        editData() {
            this.isEditing = true;
        },
        cancelEdit(){
            this.isEditing = false;
        },
        updateData(data,isReplaceImage,newLogoID) {
            data.isReplaceImage = isReplaceImage
            data.newLogoID = newLogoID
            this.$emit('update-data', data);
            //this.isEditing = false;
        },
        showTime(time){
            if (time == 24){
                return "12 a.m."
            }else if (time == 12){
                return "12 p.m."
            }else if (time < 12){
                return time + " a.m."
            }else{
                return time - 12 + " p.m."
            }
        },
        showRepeatDays(days){
            //var getDays = days.split(",")
            var daysDisplay = "";
            for (var i = 0; i < days.length; i++){
                daysDisplay = daysDisplay + this.displayDayOfWeek(days[i]) + ", "
            }
            return daysDisplay;
        },
        displayDayOfWeek(day){
            if (day == 1){
                return "Monday"
            }else if (day == 2){
                return "Tuesday"
            }else if (day == 3){
                return "Wednesday"
            }else if (day == 4){
                return "Thursday"
            }else if (day == 5){
                return "Friday"
            }else if (day == 6){
                return "Saturday"
            }else {
                return "Sunday"
            }
        }
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.myLabel{
    float: left;
    width: 15%;
    padding: 5px;
}
.badgeDropdown{
    width: 300px;
}
.badgeImage{
    width: 50px;
}
.badgeTitle{
    padding-top: 30px !important;
    float: right;
}
.myInput{
    float: left;
    width: 80%;
    padding: 5px;
}
#splash .verte__guide { height: initial; width: initial; max-height: 200px; cursor: pointer; margin-bottom: 20px;  z-index: 100;} #splash .verte__menu { top: 0; right: -10%; z-index: 200 !important; }
#splash .verte__menu---active {  z-index: 200 !important; }
#splash .verte-picker {  z-index: 200 !important; }
#splash .verte-picker---square {  z-index: 200 !important; }
</style>


// WEBPACK FOOTER //
// src/components/Database/Badges/DataView.vue